export enum EIdType {
  NONE = "0",
  NRIC = "1",
  PASSPORT_ARMY_POLICE_ID = "2",
}
